angular.module("ainapp")
    .controller("viewSalesReturnController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService) {


            $scope.PageName = "Sales Return Preview";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.init = function () {

                $scope.load = true;
                $scope.VoucherData = {};

                if ($stateParams.VoucherId > 0) {
                    $.LoadingOverlay("show", {
                        image: "images/load.gif",
                    });
                    MainService.getSalesReturnbyId($stateParams.VoucherId).then(function (response) {
                        if (response.data) {
                            $scope.VoucherData = response.data[0];
                        }
                        $scope.load = false;
                        $.LoadingOverlay("hide");
                    }, function (err) {
                        $scope.load = false;
                        toastr.error("NetworkError");
                        $.LoadingOverlay("hide");
                    })
                }

            }

            $scope.init();

            $scope.Edit = function () {
                $state.go("editSalesReturn", {
                    VoucherId: $stateParams.VoucherId
                })
            };




        }])
